import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validateLogin } from "../../../helpers";
import { authLogin, authSetToken, authSetUserCredentials } from "../../../redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useNavigate } from "react-router-dom";
import { notify } from "../../../shared/utils/notify";

export interface FormData {
  email: string;
  password: string;
}

export const useLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const formsMethods = useForm<FormData>({
    resolver: yupResolver(validateLogin),
  });

  const onLoginUser = ({ email, password }: FormData) => {
    if (isLoading) return;
    setIsLoading(true);
    
    notify.promise(
      authLogin(email, password).then((res) => {
        if (res?.accessToken) {
          dispatch(authSetToken(res?.accessToken));
          dispatch(authSetUserCredentials(res?.user));
          if (res.user.role === "seller") {
            navigate("/orders");
          } else {
            navigate("/users");
          }
          return res;
        } else {
          throw new Error("Invalid email or password.");
        }
      }),
      {
        loading: "Iniciando sesión...",
        success: "¡Bienvenido de vuelta!",
        error: (err: any) => err.message || "Error al iniciar sesión",
      }
    ).finally(() => {
      setIsLoading(false);
    });
  };

  return {
    isLoading,
    formsMethods,
    onLoginUser,
  };
};
